// extracted by mini-css-extract-plugin
export default {"wrapper":"rYk0VR"};